import type { ReactNode } from "react";
import "./OrientationButton.scss";
import classNames from "classnames";

interface Properties {
  horizontal: boolean;
  onToggleHorizontal: (h: boolean) => void;
}

export default function OrientationButton(props: Properties): ReactNode {
  return (
    <div
      className={classNames(
        "orientation-button",
        props.horizontal && "horizontal",
      )}
      onClick={() => {
        props.onToggleHorizontal(!props.horizontal);
      }}
    >
      <div className="icon" />
    </div>
  );
}
